import {
  clearJourneysListDetails,
  fetchJourneysListFail,
  fetchJourneysListStarted,
  fetchJourneysListSuccess
} from '../../../reducer/sources/JourneyListReducer';
import {
  ClearAllJourneysList,
  FetchAllJourneysFailure,
  FetchAllJourneysFailurePayload,
  FetchAllJourneysStarted,
  FetchAllJourneysSuccess,
  FetchAllJourneysSuccessPayload
} from '../../types/sources/GetAllJourneys';

/**
 * Fetch All Journeys started saga action
 * @returns Journeys started action
 */
export const getAllJourneysStarted = (): FetchAllJourneysStarted => ({
  type: fetchJourneysListStarted.type
});

/**
 * Fetch all Journeys success saga action
 * @param payload : all Journeys data
 * @returns success action
 */
export const getAllJourneysSuccess = (
  payload: FetchAllJourneysSuccessPayload
): FetchAllJourneysSuccess => ({
  type: fetchJourneysListSuccess.type,
  payload
});

/**
 * Fetch All Journeys Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchAllJourneysFailure = (
  payload: FetchAllJourneysFailurePayload
): FetchAllJourneysFailure => ({
  type: fetchJourneysListFail.type,
  payload
});

/**
 * Clear All Journeys saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearAllJourneys = (): ClearAllJourneysList => ({
  type: clearJourneysListDetails.type
});
